import { Component, Input, Output, EventEmitter } from "@angular/core";

@Component({
    selector: "app-select-amount",
    templateUrl: "./select-amount.component.html",
    styleUrls: ["./select-amount.component.scss"],
    standalone: false
})
export class SelectAmountComponent {
  @Input() amount: number;

  @Input() enable: boolean = false;

  @Input() showError: boolean = false;

  @Input() schedule: boolean = false;

  @Output() showConsiderations: EventEmitter<boolean> =
    new EventEmitter<boolean>();

  @Output() showAmounts: EventEmitter<boolean> = new EventEmitter<boolean>();
}
